<script setup>
import FixAutoApprovalDate from "@/components/approval-center/partials/ui/FixAutoApprovalDate.vue";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import ReviseRejectButton from "@/components/approval-center/partials/buttons/ReviseRejectButton.vue";

defineProps({
  approval: {
    type: Object,
    required: true,
  },
  category: {
    type: String,
    required: true,
  },
});

const emit = defineEmits([
  'approve',
  'revise',
])

</script>

<template>
  <div class="tw-flex tw-flex-col lg:tw-flex-row tw-items-center tw-text-center tw-gap-4 tw-justify-between">
    <div>
      <FixAutoApprovalDate
        :approval="approval"
      />
    </div>
    <div class="tw-flex tw-items-center tw-gap-4">
      <ReviseRejectButton
        :approval="approval"
        :category="category"
        @revise="emit('revise', approval)"
      />

      <DefaultButton @click="emit('approve', approval)">
        <svg-vue
          icon="icons/check"
          class="tw-w-4 tw-h-4 tw-mr-2"
        />
        Approve
      </DefaultButton>
    </div>
  </div>
</template>